import { fire, auth } from "../../firebase/index";
import { customLog, deploymentEnvironment } from "../../variables/Variables";

const randomString = require("randomstring");
const db = fire.database();

const inviteNewMembers = async (dataInput, callback) => {
  let membersWithoutAccArray = dataInput; //Stored all invited members by default.
  let membersWithAccArray = []; //{email : "", isAdmin : bool, memberAddedOn : timestamp}
  const superAdminId = auth.currentUser.uid;
  let companyName = "";
  const totalLengthOfMembers = membersWithoutAccArray.length;

  customLog(dataInput);

  let language = "";

  await db
    .ref("userSettings")
    .child(auth.currentUser.uid)
    .once("value")
    .then((setting) => {
      language = setting.language;
    });

  await db
    .ref("registeredIndustrialUsersOnPlatform")
    .once("value")
    .then(async (snapshot) => {
      snapshot.forEach((dbUser) => {
        const eachUserInDb = dbUser.val();
        // console.log(eachUserInDb);
        if (eachUserInDb.uid === superAdminId) {
          companyName = eachUserInDb.company;
          // customLog(companyName);
        }
        //!Sort members into "membersWithoutAccArray" & "membersWithAccArray"
        // customLog(eachUserInDb);
        // console.log(membersWithoutAccArray.length);
        for (let i = 0; i < membersWithoutAccArray.length; i++) {
          const eachMember = membersWithoutAccArray[i];

          const memberEmail = eachMember.memberEmail
            .toString()
            .replace(/\s+/g, "")
            .toLowerCase();
          var eachUserEmail = eachUserInDb.email;
          if (eachUserInDb.email != undefined && eachUserInDb.email != null) {
            eachUserEmail = eachUserInDb.email.toString().toLowerCase();

            if (eachUserEmail === memberEmail) {
              customLog("user email can be found on registered platform");
              let currExistingData = membersWithoutAccArray[i];
              currExistingData["existingUid"] = eachUserInDb.uid;
              currExistingData["existingName"] = eachUserInDb.name; // != null ? eachUserInDb.name:"melvin";
              customLog(currExistingData);
              membersWithAccArray.push(currExistingData);
              membersWithoutAccArray.splice(i, 1);
              // customLog(membersWithAccArray);
            }
          }
        }
      });
    })
    .then(async () => {
      // Get sender language preference
      let userLanguage = "";

      let addedMember = [];

      await db
        .ref("userSettings")
        .child(superAdminId)
        .once("value")
        .then((settings) => {
          userLanguage = settings.val().language;
        });

      //! Members sorted already.
      // customLog(membersWithoutAccArray.length);
      for (let i = 0; i < membersWithoutAccArray.length; i++) {
        customLog("Members without acc running :");
        const member = membersWithoutAccArray[i];
        const isAdmin = member.isAdmin;
        const memberEmail = member.memberEmail;
        let name = memberEmail.split("@");
        const formattedName = member.memberName; //name[0].replace(/\./g, "_");

        customLog("Name after formatting:");
        customLog(formattedName);

        // customLog(member);
        // customLog(isAdmin);
        // customLog(memberEmail);
        // customLog(name);

        let registerUser = await registerAndUpdateUsers(
          companyName,
          memberEmail,
          formattedName,
          isAdmin,
          userLanguage
        );

        let returnedVal = await registerUser.json();

        let notiUpdate = await updateNotification(
          returnedVal.userRecord.uid,
          superAdminId
        );

        // customLog(registerUser);
        if (registerUser) {
          customLog(
            "Success created account and update 'registeredUserOnPlatformIndustrial"
          );
          customLog("Updating GroupAccounts Now !");
          let updateGroup = await updateGroupAccounts(
            memberEmail,
            isAdmin,
            superAdminId,
            formattedName
          );

          customLog("Updating UserFriendListIndustrial Now !");
          await updateUserFriendListIndustrial(memberEmail, formattedName);

          // customLog("Updating UserFriendList Now !");
          // await updateUserFriendList(formattedName, memberEmail);

          if (updateGroup && registerUser && notiUpdate) {
            customLog("Updated group Accounts !");
            addedMember.push(memberEmail);
          } else {
            customLog("Failed to update group accounts !");
          }
        } else {
          customLog("Opps");
        }
      }

      let existingMember = [];
      let existingMemberInOther = [];

      for (let i = 0; i < membersWithAccArray.length; i++) {
        customLog("Members with acc runnin :");

        // customLog("Hello");
        const member = membersWithAccArray[i];
        const memberEmail = member.memberEmail.trim().toLowerCase();
        const isAdmin = member.isAdmin;

        const formattedName = member.memberName; //name[0].replace(/\./g, "_");

        customLog("Name after formatting:");
        customLog(formattedName);

        // const checkUserExists = await checkGroupAccountForExisting(memberEmail);
        // customLog(checkUserExists);
        const userUid = member.existingUid;

        customLog("Checking If It's a super admin");
        let isSuperAdmin = await checkSuperAdmin(userUid);
        // customLog(isSuperAdmin);

        customLog("checking group account for existing !");
        let existInCurrUserGroup = await checkGroupAccountForExisting(
          memberEmail
        );
        customLog(
          "checking group account for existing !" +
            existInCurrUserGroup.existing
        );
        // customLog(exist);

        customLog(`Checking if ${memberEmail} exists in other group`);
        let existInOtherGroup = await checkExistInOtherGroup(memberEmail);
        customLog(
          `Checking if ${memberEmail} exists in other group ` +
            existInOtherGroup
        );
        // customLog(`${memberEmail} exist = ${exist.existing}`);

        if (
          !existInCurrUserGroup.existing &&
          !isSuperAdmin &&
          !existInOtherGroup
        ) {
          let updateGroup = await updateGroupAccounts(
            memberEmail,
            isAdmin,
            superAdminId,
            formattedName
          );

          await updateUserFriendListIndustrial(
            memberEmail,
            member.existingName
          );

          // await updateUserFriendList(member.existingName, memberEmail);

          let updateNoti = await updateNotification(
            member.existingUid,
            superAdminId
          );

          const emailSendData = {
            email: memberEmail,
            name: member.existingName,
            isAdmin: isAdmin,
            language: userLanguage,
          };

          let url =
            "https://us-central1-egeetouchindustrial.cloudfunctions.net/inviteMemberWithAccTest";

          if (deploymentEnvironment) {
            url =
              "https://us-central1-egeetouchindustrial.cloudfunctions.net/inviteMemberWithAcc";
          }

          customLog("Sending email to user");
          let sendEmail = await fetch(url, {
            method: "POST",
            body: JSON.stringify(emailSendData),
          }).catch((err) => customLog(err));

          // customLog(updateUserFriendList);

          if (updateGroup && updateNoti && sendEmail) {
            customLog("Members with account updated in group account ");
            addedMember.push(memberEmail);
          } else {
            customLog(
              "Members with account failed to update in group accounts"
            );
          }
        } else if (!existInCurrUserGroup.existing && existInOtherGroup) {
          customLog(
            `${memberEmail} exists in another, skipping groupaccount update`
          );
          existingMemberInOther.push(memberEmail);
        } else {
          customLog(`${memberEmail} exists, skipping groupaccount update`);
          existingMember.push(memberEmail);
        }
      }

      customLog(existingMember);
      customLog("Ends here ====================");
      callback({
        status: true,
        existingMembers: existingMember,
        existingMembersInOther: existingMemberInOther,
        addedMembers: addedMember,
        // existingMembers: [],
        totalLengthOfMembers: totalLengthOfMembers,
      });
    })
    .catch((err) => {
      // console.log("hereeeee");
      customLog(err);
      let errorMsg = err.toString();
      addMemberErrorStoreDB(errorMsg, superAdminId);
      const dataToCallBack = {
        status: false,
        res: err,
      };
      callback(dataToCallBack);
    });
};

const getNumOfUsers = async (callback) => {
  db.ref("groupAccounts/" + auth.currentUser.uid + "/members")
    .once("value")
    .then((snapshot) => {
      callback(snapshot.numChildren());
    });
};
const registerAndUpdateUsers = async (
  companyName,
  emailAddr,
  userName,
  role,
  language
) => {
  const randomPassword = randomString.generate({
    length: 8,
    charset: "alphabetic",
  });

  //createUser
  const dataToPost = {
    email: emailAddr,
    password: randomPassword,
    company: companyName,
    name: userName,
    language: language,
  };

  let response = await fetch(
    "https://us-central1-egeetouchindustrial.cloudfunctions.net/signUpWithEmailAndPassword",
    {
      method: "POST",
      body: JSON.stringify(dataToPost),
    }
  ).catch((err) => customLog(err));

  //   customLog(response);
  // const sendEmailData = {
  //   email: emailAddr,
  //   password: randomPassword,
  //   name: userName
  // };

  const sendEmailData = {
    email: emailAddr,
    password: randomPassword,
    name: userName,
    isAdmin: role,
    language: language,
  };

  let url =
    "https://us-central1-egeetouchindustrial.cloudfunctions.net/inviteMemberWithoutAccTest";

  if (deploymentEnvironment) {
    url =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/inviteMemberWithoutAcc";
  }

  let emailSend = await fetch(url, {
    method: "POST",
    body: JSON.stringify(sendEmailData),
  }).catch((err) => customLog(err));

  customLog(emailSend);
  if (response.ok) {
    // let updateNotification = await updateNotification(uid);
    customLog("User Created");
  } else {
    customLog(response);
  }

  return response;
};

const checkSuperAdmin = async (userId) => {
  let isSuperAdmin = false;

  await db
    .ref("groupAccounts/" + userId)
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        isSuperAdmin = true;
      }
    })
    .catch((err) => customLog(err));

  return isSuperAdmin;
};

// const updateUserFriendList = async (name, email) => {
//   const uflDB = db.ref("userFriendList").child(auth.currentUser.uid);

//   customLog("updateUserFriendList() here : ");
//   uflDB
//     .child(name)
//     .once("value")
//     .then((snapshot) => {
//       if (snapshot.exists()) {
//         //Don't do anything
//       } else {
//         uflDB.child(name).set(email);
//       }
//     });
// };

const checkExistInOtherGroup = async (emailAddr) => {
  let existInOtherGroup = false;
  // const currentUser = auth.currentUser.uid;
  await db
    .ref("groupAccounts")
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        snapshot.forEach((eachSuperAdmin) => {
          const eachSuperAdminDetails = eachSuperAdmin.val();
          // const superAdminId = eachSuperAdminDetails.key;
          const superAdminMembers = eachSuperAdminDetails.members;

          for (const eachMember in superAdminMembers) {
            if (superAdminMembers[eachMember].memberEmail === emailAddr) {
              existInOtherGroup = true;
            }
          }
        });
      }
    });

  return existInOtherGroup;
};

const checkGroupAccountForExisting = async (emailAddr) => {
  customLog("checking acc existence");
  customLog(emailAddr);
  const currentUser = auth.currentUser.uid;
  let existing = false;
  let dataOfUser;

  await db
    .ref("groupAccounts/" + currentUser + "/members")
    .once("value")
    .then((snapshot) => {
      snapshot.forEach((child) => {
        const childData = child.val();
        if (childData.memberEmail === emailAddr) {
          existing = true;
          dataOfUser = child.val();
        }
      });
    });

  const datatoReturn = {
    existing: existing,
    dataOfUser: dataOfUser,
  };

  return datatoReturn;
};

const updateNotification = async (userId, superAdminId) => {
  customLog("runned");
  const today = new Date();

  const dataToUpdate = {
    createdOn: today.getTime(),
    groupName: "My First Group",
    message: "You have been invited to join My First Group",
    response: "none",
    superadminUID: superAdminId,
  };

  // customLog(userId);

  const pushKey = await db
    .ref("industrialNotifications/" + userId)
    .child("Accounts")
    .push(dataToUpdate).key;

  await db
    .ref("industrialNotifications/" + userId + "/Accounts/" + pushKey)
    .update({
      uid: pushKey,
    });

  return true;
};

const updateUserFriendListIndustrial = async (email, name) => {
  const userFriendListDb = db.ref(
    "userFriendListIndustrial/" + auth.currentUser.uid
  );

  await userFriendListDb.once("value").then(async (snapshot) => {
    let existInUserFriendListIndustrial = false;
    if (snapshot.exists()) {
      snapshot.forEach(async (eachUserKey) => {
        const eachUserDetails = eachUserKey.val();
        if (eachUserDetails.friendEmail === email) {
          existInUserFriendListIndustrial = true;
        }
      });
    }

    if (!existInUserFriendListIndustrial) {
      const dataToPush = {
        allowAccess: true, //default
        friendEmail: email,
        friendName: name,
      };

      const pushKey = await userFriendListDb.push(dataToPush).key;

      await userFriendListDb.child(pushKey).update(
        {
          id: pushKey,
        },
        (err) => {
          return true;
        }
      );
    }
  });
};

const updateGroupAccounts = async (
  emailAddr,
  isAdmin,
  superAdminId,
  formattedName
) => {
  //   customLog(superAdminId);
  const today = new Date();
  customLog("HI.. " + formattedName);
  const groupAccountSchema = db.ref(
    "groupAccounts/" + superAdminId + "/members"
  );

  const dataToPush = {
    isAdmin: isAdmin,
    memberAddedOn: today.getTime(),
    memberEmail: emailAddr,
    memberName: formattedName,
  };

  const pushKey = await groupAccountSchema.push(dataToPush).key;
  //   customLog(pushKey);
  await groupAccountSchema.child(pushKey).update({
    memberUid: pushKey,
  });

  return true;
};

const addMemberErrorStoreDB = async (errorMsg, superAdminId) => {
  //   customLog(superAdminId);
  const today = new Date();

  const storeerrSchema = db.ref("addMemberError/" + superAdminId);

  const dataToPush = {
    error: errorMsg,
    occurOn: today.getTime(),
  };

  storeerrSchema.push(dataToPush);

  return true;
};

// const getUserLocks = async email => {
//   let userLocks = [];

//   const emailAddr = {
//     email: email
//   };

//   await fetch(
//     "https://us-central1-egeetouchindustrial.cloudfunctions.net/getUserByEmail",
//     {
//       method: "POST",
//       body: JSON.stringify(emailAddr)
//     }
//   )
//     .then(async result => {
//       const returnedVal = await result.json();
//       const uid = returnedVal.uid;

//       await fetch(
//         "https://us-central1-egeetouchindustrial.cloudfunctions.net/getUserLocksByUID",
//         {
//           method: "POST",
//           body: uid
//         }
//       )
//         .then(async userLockResponse => {
//           const userLockVal = await userLockResponse.json();
//           const datas = userLockVal.snapshotVal;

//           userLocks = datas;
//         })
//         .catch(err => customLog(err));

//       // customLog(uid);
//     })
//     .catch(err => customLog(err));

//   return userLocks;
// };

const getUserLocksOld = async (email) => {
  try {
    const userId = await getUserId(email);
    const userLocks = [];

    const superadminUID = auth.currentUser.uid;

    const userLocksDB = fire.database().ref("userLocks");

    await userLocksDB
      .child(userId)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((childSnapshot) => {
            let childSnapshotVal = childSnapshot.val();

            let obj = {
              ip45SerialNumber: childSnapshotVal.ip45SerialNumber,
              Name: childSnapshotVal.Name,
              status: "Individual",
            };
            userLocks.push(obj);
          });
        }
      });

    return userLocks;
  } catch (error) {
    customLog(error);
    throw error;
  }
};

const getUserLocks = async (email) => {
  try {
    const superadminUID = auth.currentUser.uid;
    const userId = await getUserId(email);
    const userLocks = [];

    // 1. Get Individual Locks
    const userLocksRef = fire
      .database()
      .ref("userLocks")
      .child(userId);
    const userLocksSnapshot = await userLocksRef.once("value");

    if (userLocksSnapshot.exists()) {
      userLocksSnapshot.forEach((child) => {
        const data = child.val();
        userLocks.push({
          ip45SerialNumber: data?.ip45SerialNumber || null,
          Name: data?.Name || null,
          status: "Individual",
        });
      });
    }

    // 2. Get Group Locks based on userGroups
    const groupsRef = fire
      .database()
      .ref(`groupAccounts/${superadminUID}/userGroups/${userId}/groups`);

    const groupsSnapshot = await groupsRef.once("value");

    if (groupsSnapshot.exists()) {
      const groupsData = groupsSnapshot.val();

      for (const groupKey in groupsData) {
        const groupInfo = groupsData[groupKey];
        const groupID = groupInfo?.groupID;
        const groupAdminUID = groupInfo?.groupAdminUID;

        if (!groupID || !groupAdminUID) continue;

        const groupRef = fire
          .database()
          .ref(`GroupManagement/${superadminUID}/${groupAdminUID}/${groupID}`);

        const groupSnapshot = await groupRef.once("value");

        if (groupSnapshot.exists()) {
          const groupVal = groupSnapshot.val();
          const groupName = groupVal?.groupName || "Unnamed";

          const groupLocks = groupVal?.groupLocks || {};
          for (const lockKey in groupLocks) {
            const lock = groupLocks[lockKey];
            userLocks.push({
              ip45SerialNumber: lock?.ip45SerialNumber || null,
              Name: lock?.Name || null,
              status: `${groupName} - Group`,
            });
          }
        }
      }
    }

    return userLocks;
  } catch (error) {
    customLog(error);
    throw error;
  }
};

// const deleteUserLock = async (lockSerial) => {};

const getPlanofSuperAdmin = (callback) => {
  db.ref("groupAccounts/" + auth.currentUser.uid)
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        const snapshotVal = snapshot.val();
        const members = snapshotVal.members;
        const maxNumOfAccs = snapshotVal.payment.maxUsers;

        let currNumOfUsers = Object.keys(members).length;

        const dataToCallBack = {
          currNumOfUsers: currNumOfUsers,
          maxUsers: maxNumOfAccs,
        };

        callback(dataToCallBack);
      }
    })
    .catch((err) => customLog(err));
};

const getUserId = async (email) => {
  const url =
    "https://us-central1-egeetouchindustrial.cloudfunctions.net/getUserByEmail";

  let userId = "";

  await fetch(url, {
    method: "POST",
    body: JSON.stringify({ email: email }),
  }).then(async (response) => {
    const responseResult = await response.json();
    userId = responseResult.uid;
  });

  return userId;
};

const getUserName = async (uid) => {
  let userName = "";

  await db
    .ref("registeredIndustrialUsersOnPlatform/" + uid)
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        const userDetails = snapshot.val();
        userName = userDetails.name;
      }
    });

  return userName;
};

const getDetailsAndUpdateDB = async (email, res) => {
  // console.log("running");
  let userId = await getUserId(email);
  let userName = await getUserName(userId);

  let updateResponse = await updateDatabase(userName, email);

  if (!updateResponse) {
    res(false);
  } else {
    updateResponse["status"] = true;

    // console.log(updateResponse);
    res(updateResponse);
  }
};

const updateDatabase = async (name, email) => {
  let dataCallBack = {
    friendName: name,
    friendEmail: email,
  };

  const currentUserID = auth.currentUser.uid;
  const userFriendListDB = fire.database().ref("userFriendList");
  const userFriendListIndustrialDB = fire
    .database()
    .ref("userFriendListIndustrial");
  const registeredUsersOnPlatformDB = fire
    .database()
    .ref("registeredUsersOnPlatform");
  const historicalRecipientsDB = fire.database().ref("historicalRecipients");

  let userExist = false;

  await userFriendListIndustrialDB
    .child(auth.currentUser.uid)
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        const snapshotVal = snapshot.val();
        for (const eachFriendId in snapshotVal) {
          if (snapshotVal[eachFriendId].friendEmail === email) {
            userExist = true;
          }
        }
      }
    });

  if (userExist) {
    return false;
  }

  await registeredUsersOnPlatformDB
    .orderByValue()
    .once("value")
    .then(async (snapshot) => {
      if (email !== snapshot.val()) {
        userFriendListDB
          .child(currentUserID)
          .child(name)
          .set(email);

        let friendListKey = await userFriendListIndustrialDB
          .child(currentUserID)
          .push().key;

        const industrialRecipientDetails = {
          allowAccess: true,
          friendEmail: email,
          friendName: name,
          id: friendListKey,
        };

        await userFriendListIndustrialDB
          .child(currentUserID)
          .child(friendListKey)
          .set(industrialRecipientDetails);

        let historicalKey = await historicalRecipientsDB
          .child(currentUserID)
          .push().key;

        const recipientDetails = {
          dateTimeAdded: new Date() / 1000,
          email: email,
          name: name,
          id: historicalKey,
        };

        await historicalRecipientsDB
          .child(currentUserID)
          .child(historicalKey)
          .set(recipientDetails);
      }
    });

  return dataCallBack;
};

const checkIfMembersWithinRange = async (
  superAdminId,
  numOfMembers,
  validRangeCallback
) => {
  db.ref("groupAccounts/" + superAdminId + "/payment")
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        const planMaxUsers = snapshot.val().maxUsers;

        if (numOfMembers === planMaxUsers) {
          validRangeCallback(false);
        } else {
          validRangeCallback(true);
        }
      }
    });
};

const getRecipientFriendList = async (email) => {
  try {
    let userId = await getUserId(email);
    let ReceipientFriendList = [];

    const userFriendListIndustrialDB = fire
      .database()
      .ref("userFriendListIndustrial");

    await userFriendListIndustrialDB
      .child(userId)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          const snapshotVal = snapshot.val();
          snapshot.forEach((childSnapshot) => {
            let childSnapVal = childSnapshot.val();

            let obj = {
              friendEmail: childSnapVal.friendEmail,
              friendName: childSnapVal.friendName,
            };
            ReceipientFriendList.push(obj);
          });
        }
      });

    return { ReceipientFriendList, userId };
  } catch (error) {
    // Handle any errors
    // console.log(error);
    throw error;
  }
};

const getRecipientFriendListSuperAdmin = async (email) => {
  let userId = await getUserId(email);
  // console.log(userId);
  const db = fire.database();
  const groupAccounts = db.ref("groupAccounts");
  const userFriendListIndustrial = db.ref("userFriendListIndustrial");

  const membersInsideGroup = [];

  // console.log(auth.currentUser.email);

  return new Promise((resolve, reject) => {
    groupAccounts.once("value").then((snapshot) => {
      snapshot.forEach((superAdminDetails) => {
        const detailsVal = superAdminDetails.val();
        const members = detailsVal.members;
        for (const eachMember in members) {
          const memberDetails = members[eachMember];
          if (memberDetails.memberEmail === auth.currentUser.email) {
            for (const membersUnderSameAdmin in members) {
              if (!members[membersUnderSameAdmin].isSuperAdmin) {
                membersInsideGroup.push(members[membersUnderSameAdmin]);
              }
            }
            userFriendListIndustrial
              .child(userId)
              .once("value")
              .then((snapshot) => {
                snapshot.forEach((eachFriend) => {
                  const eachFriendDetails = eachFriend.val();
                  const eachFriendEmail = eachFriendDetails.friendEmail;

                  const idx = membersInsideGroup.findIndex(
                    (eachMember) => eachMember.memberEmail === eachFriendEmail
                  );

                  if (idx >= 0) {
                    membersInsideGroup.splice(idx, 1);
                  }
                });
                resolve({ membersInsideGroup, userId });
              });
          }
        }
      });
    });
  });
};

export {
  getDetailsAndUpdateDB,
  inviteNewMembers,
  getUserLocks,
  getPlanofSuperAdmin,
  getNumOfUsers,
  checkIfMembersWithinRange,
  getRecipientFriendList,
  getRecipientFriendListSuperAdmin,
};
